import { MemberType } from "../../../../Enums/PersonEnums";
import type { IPersonCreate } from "../../../../interfaces/models/IPersonCreate";

export function getEmptyPersonCreate(overrides: Partial<IPersonCreate> = {}): IPersonCreate {
  return {
    memberType: MemberType.member,
    firm: "",
    name: "",
    lastName: "",
    title: "",
    unlistedTitle: "",
    unlistedTitleToggle: false,
    firmEmail: "",
    additionalOffices: [],
    isAttorney: false,
    isSearchable: false,
    isWsgMember: false,
    hasAssistant: false,
    socialNetworks: [],
    username: "",
    ...overrides,
  };
}
